<template>
    <div class="box">
        <div class="headbox" :class="index != dataList.length - 1 ? 'btmold' : ''" v-for="(item, index) of dataList"
            :key="index">
            <div class="dis_f">
                <img :src="item.icon" width="18" height="20" alt="">
                <span>{{ item.title }}</span>
            </div>
            <div :class="v.info == currentInfo ? 'curr' : 'lable'" v-for="(v, j) of item.const"
                @click="checkAdd(index, j, v.info)" :key="j">
                <div class="find" v-if="v.info == currentInfo"></div>
                {{ v.name }}
            </div>
        </div>
    </div>
</template>

<script>
import { createLogger } from 'vuex';

export default {
    name: '',
    data() {
        return {
            dataIndex: 0,
            dataList: [
                {
                    title: '会员中心',
                    icon: require('../../image/hyzx.png'),
                    const: [
                        {
                            name: '账号信息',
                            path: 'ProfileInfo',
                            info: 0
                        },
                        {
                            name: '登录设置',
                            path: 'ProfileLogin',
                            info: 1
                        },
                        {
                            name: '我的收藏',
                            path: 'ProfileCollect',
                            info: 2
                        }
                    ]
                },
                {
                    title: '我的发布',
                    icon: require('../../image/wdfb.png'),
                    const: [
                        {
                            name: '我要发布',
                            path: 'PublishRelease',
                            info: 3
                        },
                        {
                            name: '我的求租',
                            path: 'PublishRent',
                            params: 0,
                            info: 4
                        },
                        {
                            name: '我的出租',
                            path: 'PublishRent',
                            params: 1,
                            info: 5
                        },
                        {
                            name: '我的转让',
                            path: 'PublishRent',
                            params: 2,
                            info: 6
                        },
                        {
                            name: '发布视频房源',
                            path: 'PublishVideoProperty',
                            info: 7
                        },
                        {
                            name: '我的视频房源',
                            path: 'MyVideoProperty',
                            info: 8
                        }
                    ]
                },
                {
                    title: '帮助中心',
                    icon: require('../../image/bzzx.png'),
                    const: [
                        {
                            name: '联系客服',
                            path: 'HelpContact',
                            info: 10
                        },
                        {
                            name: '在线留言',
                            path: 'HelpLeave',
                            info: 11
                        },
                        {
                            name: '进入小程序',
                            path: 'HelpMini',
                            info: 12
                        }
                    ]
                }
            ]
        };
    },
    created() {

    },
    mounted() {

    },
    computed: {
        // 根据当前路由计算出高亮项的 info
        currentInfo() {
            const currentRoute = this.$route;
            for (let i = 0; i < this.dataList.length; i++) {
                const group = this.dataList[i];
                for (let j = 0; j < group.const.length; j++) {
                    const item = group.const[j];
                    if (item.path === currentRoute.name) {
                        // 如果路由需要 params 参数，则进一步校验 query.type
                        if (item.params !== undefined && item.params !== null) {
                            if (Number(currentRoute.query.type) === item.params) {
                                return item.info;
                            }
                        } else {
                            return item.info;
                        }
                    }
                }
            }
            return 0; // 默认高亮
        }
    },
    methods: {
        checkAdd(index, j, info) {
            console.log(index, j, info, '000')

            // this.$nextTick(() => {
            this.dataIndex = info
            // });
            if(this.dataList[index].const[j].path=='PublishRelease'){
                this.$router.push({ name:'PublishRelease',query:{ dataIndex: 0 }})
            }else{
                if (this.dataList[index].const[j].params >= 0) {
                this.$router.push({ name: this.dataList[index].const[j].path, query: { type: this.dataList[index].const[j].params } })
            } else {
                this.$router.push({ name: this.dataList[index].const[j].path })
            }
            }
           

        }
    },
}
</script>
<style scoped lang='less'>
.box {
    width: 192px;
    // height: 712px;
    background: #FFFFFF;
    border-radius: 6px 6px 6px 6px;
    // margin: 25px 0;

    .btmold {
        border-bottom: 1px solid #DFDFDF;
    }

    .headbox {
        cursor: pointer;

        .dis_f {
            display: flex;
            align-items: center;
            width: 120px;
            margin: 25px auto 0;
            padding-bottom: 10px;

            img {}

            span {
                font-weight: bold;
                font-size: 16px;
                color: #333333;
                margin-left: 20px;

            }
        }

        .lable {
            // width: 100px;
            height: 50px;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            text-align: center;
            margin: 5px auto;
            line-height: 50px;
        }

        .curr {
            width: 192px;
            height: 50px;
            background: #E8F2FE;
            border-radius: 0px 0px 0px 0px;
            font-weight: 500;
            font-size: 14px;
            color: #0074FF;
            text-align: center;
            line-height: 50px;
            margin: 5px 0;
            position: relative;

            .find {
                width: 4px;
                height: 20px;
                border-radius: 16px;
                background-color: #0074FF;
                position: absolute;
                left: 0;
                top: 0;
                transform: translate(-50%, 50%);
            }
        }
    }
}
</style>